export const testimonials = [
  {
    id: 1,
    service: "Microsoft",
    quote:
      "Protrexa modernized our entire Microsoft workspace — Teams, Outlook, OneDrive, and device policies. Everything is finally synced, secure, and running smoothly across the company.",
    name: "Mabel Clément",
    role: "Co-Founder",
    company: "Northbridge Commerce",
    rating: 5,
    photo:
      "https://images.pexels.com/photos/774909/pexels-photo-774909.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=240&h=240&fit=crop",
    logo: "/logos/northbridge.svg",
  },
  {
    id: 2,
    service: "Accounting & Bookkeeping",
    quote:
      "Our accounting workflows were a mess until Protrexa connected QuickBooks, invoices, reconciliation, and reporting. Month-end closing that took days now takes less than two hours.",
    name: "Ari Dupont",
    role: "Finance Lead",
    company: "Lumina Creative Studio",
    rating: 5,
    photo:
      "https://images.pexels.com/photos/2379005/pexels-photo-2379005.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=240&h=240&fit=crop",
    logo: "/logos/lumina.svg",
  },
  {
    id: 3,
    service: "Printer Support",
    quote:
      "We stopped wasting time on printer errors and network issues. Protrexa handles setup, monitoring, drivers, and on-call fixes — our office hasn’t had a print outage in months.",
    name: "Danielle Moore",
    role: "Operations Manager",
    company: "Glowhouse Media",
    rating: 5,
    photo:
      "https://images.pexels.com/photos/415829/pexels-photo-415829.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=240&h=240&fit=crop",
    logo: "/logos/glowhouse.svg",
  },
  {
    id: 4,
    service: "Antivirus & EDR",
    quote:
      "With Protrexa’s EDR monitoring and security patching, our infrastructure finally feels protected. We get real-time alerts, automated isolation, and weekly threat reports we actually understand.",
    name: "Victor Chan",
    role: "Head of IT",
    company: "Skyline Mobility Group",
    rating: 5,
    photo:
      "https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=240&h=240&fit=crop",
    logo: "/logos/skyline.svg",
  },
  {
    id: 5,
    service: "Web Development",
    quote:
      "Protrexa rebuilt our website with fast load speeds, SEO-ready structure, and clean UI. It now converts better, ranks faster, and is far easier for our team to maintain.",
    name: "Ananya Rao",
    role: "Founder",
    company: "Brightpath Academy",
    rating: 5,
    photo:
      "https://images.pexels.com/photos/762020/pexels-photo-762020.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=240&h=240&fit=crop",
    logo: "/logos/brightpath.svg",
  },
  {
    id: 6,
    service: "CRM Development",
    quote:
      "Protrexa built a custom CRM for our sales and support teams — pipelines, roles, automation, and reporting. We finally have a system tailored to our workflow, not the other way around.",
    name: "David K.",
    role: "Chief Technology Officer",
    company: "Harborline Legal Group",
    rating: 5,
    photo:
      "https://images.pexels.com/photos/819530/pexels-photo-819530.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=240&h=240&fit=crop",
    logo: "/logos/harborline.svg",
  },
];

export const logos = [
  "/logos/hp.svg",
  "/logos/zoho.svg",
  "/logos/stripe.svg",
  "/logos/quickbooks.svg",
  "/logos/wordpress.svg",
  "/logos/microsoft365.svg",
];
